<template>
    <div id="solutionPageTitle" class="my-title">{{text}}</div>
</template>

<script>
    export default {
      name: "myTitle",
      data(){
        return{
          text: String,
        }
      },
      props:{
        titleText: String,
      },
      mounted() {
        this.text = this.titleText;
      }
    }
</script>

<style scoped>
  #solutionPageTitle{
    position: relative;
    padding: 0;
    margin: 95px 0 0 0;
    height: 26px;
    font-size: 26px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #444444;
    line-height: 26px;
  }
  #solutionPageTitle::before{
    content: '';
    position: absolute;
    bottom: -22px;
    left: 50%;
    transform: translateX(-50%);
    height: 4px;
    width: 53px;
    background: #FEB550;
  }

</style>
